import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { Analytics } from "@accessdev/arc-ui-react";

function AddOns() {
  const member = useSelector(selectors.getAddOnsMemberAccountInfo);
  const program = useSelector(selectors.getAddOnsProgramInfo);
  const domains = useSelector(selectors.getProgramDomains);
  const allowedEnvs = ["stage", "production"];
  const env = process.env.REACT_APP_ENV || "development";
  if (allowedEnvs.includes(env)) {
    const supportedDomains = [domains.app, domains.travel.replace("https://", "")];
    return <Analytics program={program} member={member} domains={supportedDomains} />;
  }
  return null;
}

export default AddOns;
